import { SpecialOrdersReferral } from '@/scripts/optional/special-orders-referral'
import { TsDOM as q } from '@/scripts/core/TsDOM'

q.safeDefineElement(SpecialOrdersReferral)
